import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Client } from "../../api-client/api-client";
import {
  GET_MASTER_DROPDOWN,
  GET_MASTER_FILE_STATUS,
  GET_MASTER_IBL_MONTH,
  GET_MASTER_IBL_PERIOD,
  GET_MASTER_TICKET_CATEGORY,
  GET_MASTER_TICKET_SUB_CATEGORY,
} from "../../route/api.routes";
const config = {
  name: "settings",
};

export const fetchMasterIblPeriod: any = createAsyncThunk(
  `${config.name}/fetchMasterIblPeriod`,
  async (params: any) => {
    return await Client.get(GET_MASTER_IBL_PERIOD, { params });
  }
);
export const fetchMasterIblMonth: any = createAsyncThunk(
  `${config.name}/fetchMasterIblMonth`,
  async (params: any) => {
    return await Client.get(GET_MASTER_IBL_MONTH, { params });
  }
);
export const fetchMasterTicketCategory: any = createAsyncThunk(
  `${config.name}/fetchMasterTicketCategory`,
  async (params: any) => {
    return await Client.get(GET_MASTER_TICKET_CATEGORY, { params });
  }
);
export const fetchMasterTicketSubCategory: any = createAsyncThunk(
  `${config.name}/fetchMasterTicketSubCategory`,
  async (params: any) => {
    return await Client.get(GET_MASTER_TICKET_SUB_CATEGORY, { params });
  }
);
export const fetchMasterDropdown: any = createAsyncThunk(
  `${config.name}/fetchMasterDropdown`,
  async (params: any) => {
    return await Client.get(GET_MASTER_DROPDOWN, { params });
  }
);
export const fetchMasterFileStatusList: any = createAsyncThunk(
  `${config.name}/fetchMasterFileStatusList`,
  async (params: any) => {
    return await Client.get(GET_MASTER_FILE_STATUS, { params });
  }
);

export const settingsSlice = createSlice({
  name: config.name,
  initialState: {
    modalOpened: false,
    master_ibl_month: [],
    master_ibl_period: [],
    master_ticket_category: [],
    master_ticket_sub_category: [],
    master_dropdown: [],
    master_file_status: [],
    error: "",
    loading: false,
  },
  reducers: {
    reset: (state) => {
      state.modalOpened = false;
      state.master_ibl_month = [];
      state.master_ibl_period = [];
      state.master_ticket_category = [];
      state.master_ticket_sub_category = [];
      state.master_dropdown = [];
      state.master_file_status = [];
    },
    resetIblMonth: (state) => {
      state.master_ibl_month = [];
    },
    resetTicketCategory: (state) => {
      state.master_ticket_category = [];
    },
    resetTicketSubCategory: (state) => {
      state.master_ticket_sub_category = [];
    },
    toggleModal: (state) => {
      state.modalOpened = !state.modalOpened;
    },
    setBlurModal: (state, action) => {
      state.modalOpened = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchMasterIblPeriod.pending, (state) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(fetchMasterIblPeriod.fulfilled, (state, action) => {
        state.loading = false;
        state.master_ibl_period = action?.payload?.data?.data;
      })
      .addCase(fetchMasterIblPeriod.rejected, (state) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(fetchMasterIblMonth.pending, (state) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(fetchMasterIblMonth.fulfilled, (state, action) => {
        state.loading = false;
        state.master_ibl_month = action?.payload?.data;
      })
      .addCase(fetchMasterIblMonth.rejected, (state) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(fetchMasterTicketCategory.pending, (state) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(fetchMasterTicketCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.master_ticket_category = action?.payload?.data?.data;
      })
      .addCase(fetchMasterTicketCategory.rejected, (state) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(fetchMasterTicketSubCategory.pending, (state) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(fetchMasterTicketSubCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.master_ticket_sub_category = action?.payload?.data?.data;
      })
      .addCase(fetchMasterTicketSubCategory.rejected, (state) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(fetchMasterDropdown.pending, (state) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(fetchMasterDropdown.fulfilled, (state, action) => {
        state.loading = false;
        state.master_dropdown = action?.payload?.data?.data;
      })
      .addCase(fetchMasterDropdown.rejected, (state) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(fetchMasterFileStatusList.pending, (state) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(fetchMasterFileStatusList.fulfilled, (state, action) => {
        state.loading = false;
        let data = action?.payload?.data?.data;
        let ret:any = [];
        Object.keys(data)?.map((val:any)=>{
          ret.push({
            name: data[val],
            value: val
          })
        })
        state.master_file_status = ret
      })
      .addCase(fetchMasterFileStatusList.rejected, (state) => {
        state.loading = false;
        state.error = "";
      });
  },
});

export const {
  reset,
  toggleModal,
  setBlurModal,
  resetTicketCategory,
  resetTicketSubCategory,
  resetIblMonth,
} = settingsSlice.actions;

export default settingsSlice.reducer;
